import React from 'react';
import './style.scss';
import clsx from 'clsx';

export const CustomAutocompleteArrowIcon = ({ className, color = '#2A5082' }) => (
  <div className={clsx('custom-autoselect-arrow', className)}>
    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.292893 0.295213C0.683417 -0.0953118 1.31658 -0.0953118 1.70711 0.295213L5.5 4.08811L9.29289 0.295213C9.68342 -0.0953118 10.3166 -0.0953118 10.7071 0.295213C11.0976 0.685737 11.0976 1.3189 10.7071 1.70943L6.20711 6.20943C5.81658 6.59995 5.18342 6.59995 4.79289 6.20943L0.292893 1.70943C-0.0976311 1.3189 -0.0976311 0.685737 0.292893 0.295213Z"
        fill={color}
      />
    </svg>
  </div>
);

export const CustomAutocompleteDeleteIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0.953125C4.477 0.953125 0 5.43013 0 10.9531C0 16.4761 4.477 20.9531 10 20.9531C15.523 20.9531 20 16.4761 20 10.9531C20 5.43013 15.523 0.953125 10 0.953125ZM10 2.95312C14.418 2.95312 18 6.53512 18 10.9531C18 15.3711 14.418 18.9531 10 18.9531C5.582 18.9531 2 15.3711 2 10.9531C2 6.53512 5.582 2.95312 10 2.95312ZM7 6.95312C6.744 6.95312 6.47701 7.03913 6.28101 7.23413C5.89101 7.62513 5.89101 8.28112 6.28101 8.67212L8.562 10.9531L6.28101 13.2341C5.89101 13.6251 5.89101 14.2811 6.28101 14.6721C6.67201 15.0621 7.32799 15.0621 7.71899 14.6721L10 12.3911L12.281 14.6721C12.672 15.0621 13.328 15.0621 13.719 14.6721C14.109 14.2811 14.109 13.6251 13.719 13.2341L11.438 10.9531L13.719 8.67212C14.109 8.28112 14.109 7.62513 13.719 7.23413C13.523 7.03913 13.256 6.95312 13 6.95312C12.744 6.95312 12.477 7.03913 12.281 7.23413L10 9.51512L7.71899 7.23413C7.52299 7.03913 7.256 6.95312 7 6.95312Z"
      fill="#003DA6"
    />
  </svg>
);
